import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { traceRouting } from '../../utils/routingDebug';

const DESTINATION = {
  renewal_unpaid: '/billing/renewal',
  subscription_canceled: '/billing/required',
};

/**
 * #759 PR R — escucha `billing:renewal` (lo emite `dispatchBillingError` en apiClient con un 402
 * `renewal_unpaid` o `subscription_canceled`) y lleva a la pantalla que toca: la de pagar la
 * renovación, o la de elegir plan si la suscripción de Stripe ya se canceló.
 *
 * Montado una vez en App.jsx, junto a <TrialExpiredListener />. No pinta nada.
 */
const RenewalListener = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handler = (event) => {
      const to = DESTINATION[event?.detail?.error];
      if (!to || location.pathname === to) return;
      traceRouting('RenewalListener', 'Navigate', { to, reason: event.detail.error, endpoint: event.detail.endpoint });
      navigate(to, { replace: true });
    };
    window.addEventListener('billing:renewal', handler);
    return () => window.removeEventListener('billing:renewal', handler);
  }, [navigate, location.pathname]);

  return null;
};

export default RenewalListener;
